import { render } from "./motion-info-cell.vue?vue&type=template&id=3359ed90"
import script from "./motion-info-cell.vue?vue&type=script&lang=js"
export * from "./motion-info-cell.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__